<template>
  <p-dialog
    :value="value"
    @input="$emit('input', $event)"
    id="videoFrame"
    max-width="500"
    no-padding
    :title="`${$t('Account.help')} ${toolbarTitle ? $t('Drawer.' + toolbarTitle) : ''}`"
  >
    <div class="px-4 py-4 d-flex align-center">
      <p-icon>
        <PFile />
      </p-icon>
      <p-text class="pl-2">{{ $t('HelpAndTutorials.helpCenter') }} </p-text>
      <v-spacer></v-spacer>
      <p-btn url="https://www.opinew.com/help-center/">{{ $t('Account.open') }}</p-btn>
    </div>

    <v-divider />
    <div class="px-4 py-4 d-flex align-center">
      <p-icon>
        <PPlayCircle />
      </p-icon>
      <p-text class="pl-2">{{ $t('HelpAndTutorials.videoTutorials') }}</p-text>
      <v-spacer></v-spacer>
      <p-btn url="https://www.youtube.com/@opinew4665/videos">{{
        $t('HelpAndTutorials.watch')
      }}</p-btn>
    </div>
    <template #footer>
      <p-btn @click="openChat" variant="primary">
        {{ $t('Seo.contactSupport') }}
      </p-btn>
    </template>
  </p-dialog>
</template>

<script>
import PDialog from '@/components/polaris/PDialog';
import PBtn from '@/components/polaris/PBtn';
import { getPIconComponents } from '@/components/polaris/polarisUtils';
import PIcon from '@/components/polaris/PIcon';
import PText from '@/components/polaris/PText';
export default {
  name: 'HelpVideosDialog',
  components: {
    PDialog,
    PBtn,
    PText,
    PIcon,
    ...getPIconComponents(['File', 'PlayCircle', 'Link', 'Target']),
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    toolbarTitle: {
      type: String,
      default: '',
    },
  },
  methods: {
    openChat() {
      window.fcWidget && window.fcWidget.open();
      this.closeModal();
    },
    closeModal() {
      this.$emit('input', false);
    },
  },
};
</script>

<style scoped>
.pointer-cursor {
  cursor: pointer;
}
.help-video {
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.help-video-play-icon {
  position: absolute;
  font-size: 3.5em;
  color: #c0c0c0;
  opacity: 0.85;
}
</style>
